import React, { useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
const Watchnowmodal = (props) => {
    const [btih, setbtih] = useState(null);
    const DetailMovies = props.data;
    return (
        <div>
            <Modal {...props} size="lg" centered aria-labelledby="contained-modal-title-vcenter" className="border-0">
                <Modal.Header className="bg-secondary border-0" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h5 className="modal-title w-100 text-center text-warning text-capitalize">Select movie quality</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark rounded-bottom">
                    <Row>
                        {DetailMovies?.torrents && DetailMovies?.torrents.map((file, index) => {
                            return (
                                <Col className="border p-3 rounded-3 m-2 text-center" key={index}>
                                    <p className="text-white-50">WEB</p>
                                    <div>
                                        {file.quality === "2160p" && <i className="icon-4k"></i>}
                                        {file.quality === "1080p" && <i className="icon-1080"></i>}
                                        {file.quality === "720p" && <i className="icon-720"></i>}
                                    </div>
                                    {/* <h5 className="mt-2">{file.quality}</h5>
                                    <p className="text-white-50">File size</p>
                                    <h5>{file.size}</h5> */}
                                    {/* <a target="_blank" rel="noreferrer" href={`magnet:?xt=urn:btih:${file.hash}&amp;dn=Space+Jam%3A+A+New+Legacy+%282021%29+%5B2160p%5D+%5BYTS.MX%5D&amp;tr=udp%3A%2F%2Ftracker.opentrackr.org%3A1337%2Fannounce&amp;tr=udp%3A%2F%2Ftracker.leechers-paradise.org%3A6969%2Fannounce&amp;tr=udp%3A%2F%2F9.rarbg.to%3A2710%2Fannounce&amp;tr=udp%3A%2F%2Fp4p.arenabg.ch%3A1337%2Fannounce&amp;tr=udp%3A%2F%2Ftracker.cyberia.is%3A6969%2Fannounce&amp;tr=http%3A%2F%2Fp4p.arenabg.com%3A1337%2Fannounce&amp;tr=udp%3A%2F%2Ftracker.internetwarriors.net%3A1337%2Fannounce`} title={DetailMovies && DetailMovies.title}>Watch now</a> */}
                                    <button onClick={() => setbtih(file.hash)} className="btn btn-warning w-100 text-white btn-lg fw-bol my-3 btn-block"><i className="bi bi-download"></i> WATCH</button>

                                </Col>
                            )
                        })}

                    </Row>
                    <Row>
                        <Col>
                            <h1>{btih}</h1>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Watchnowmodal;
